<<!--  -->
<template>
  <div class="calendar-box">
    <div class="statistical">
        <el-date-picker
          v-model="month"
          type="month"
          placeholder="选择要查看的月份"
          size='large'
        ></el-date-picker>
    </div>
    <div class='cale-box'>
        <div class='cale-box-li mr-20'>
          <div class='cale-greas'></div>
          未完成的带货任务
        </div>
        <div class='cale-box-li'>
          <div class='cale-grea'></div>
          带货任务均已结束
        </div>
    </div>
    <div class="calendar-base">
      <el-calendar
        v-model="month"
      >
        <template
          slot="dateCell"
          slot-scope="{ data }"
        >
          <div class="date-cell" @click="showKolInfo(schedule[data.day], data.day)">
            <p>
              <span :class="today==data.day?'today':'today-d'">{{ data.day.split('-').slice(2).join('-') }}</span>
            </p>
            <ul class="schedule" v-if="schedule[data.day]">
              <li v-for="(info, index) in schedule[data.day]" :key="info.id">
                <div v-if="index < listCount">
                  <el-popover
                    placement="top"
                    trigger="hover"
                    v-if="info.count_color=='purple'"
                  >
                    <div class="popover-box">
                      <p>达人档期为</p>
                      <p>{{info.kol_time_begin}}&nbsp;~&nbsp;{{info.kol_time_end}}</p>
                      <p>请持续关注</p>
                    </div>
                    <div
                      v-if="info.kol_user"
                      slot="reference"
                    >
                      <p
                        class="purple"
                        @click="goInfopage(info.id, data.day, month)"
                      >
                        <em>{{ info.kol_user.nickname }}</em>
                        <span>{{ info.count_suc }}/{{ info.count_all }}任务</span>
                      </p>
                    </div>
                  </el-popover>
                  <div v-else>
                    <div
                      v-if="info.kol_user"
                    >
                      <p
                        class="grey"
                        @click="goInfopage(info.id, data.day, month)"
                      >
                        <em>{{ info.kol_user.nickname }}</em>
                        <span>{{ info.count_suc }}/{{ info.count_all }}任务</span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <span class='more' v-if="schedule[data.day] && schedule[data.day].length > listCount">查看更多</span>
          </div>
        </template>
      </el-calendar>
    </div>
    <el-dialog
      :title="drawerInfo.date + ' 带货速览'"
      :visible.sync="drawer"
      center
    >
      <div class="drawer-box">
        <p class="drawer-tit">共计<span>{{drawerInfo.kol_list && drawerInfo.kol_list.length}}</span>位达人为您带货，请关注！</p>
        <ul class="kol-list">
          <li
            v-for="info in drawerInfo.kol_list"
            :key="info.id"
            @click="goInfopage(info.id, drawerInfo.date, month)"
          >
          
            <div class="flex-box">
              <div class="img-box">
                <img :src="info.img" alt="">
              </div>
              <div class="kol-info">
                <el-link :href="info.home_link" target="_blank" type="primary" :underline="false"><p>【{{info.type_name}}】{{info.nickname}}</p></el-link>
                <p>粉丝：{{info.fans}}</p>
                <p>档期：{{info.kol_time_begin}}&nbsp;~&nbsp;{{info.kol_time_end}}</p>
              </div>
            </div>
            <p>任务完成/全部任务数：{{info.count_suc}}/{{info.count_all}}</p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import basics from "@/config/basics.js";
export default {
  name: "usercalendar",
  data() {
    return {
      listCount: 2, // 日历格子展示几条信息
      drawer: false, // 当前页就一个抽屉，所以只做一个开关，内容通过data来控制。
      drawerInfo: {}, // 抽屉显示内容
      statistical: {}, // 
      month: new Date(), // 当前月份
      schedule: {}, // 当月数据，key为日期，value为列表。
      today:utils.dateFormat(new Date()).ymd
    };
  },
  components: {},
  created() {
    this.getData();
    console.log(utils.dateFormat(new Date()).ymd)
  },
  watch: {
    month(month, oldMonth) {
      // 点击日历判断月份是否变更，未变更则不更新数据
      let date = utils.dateFormat(month);
      let oldDate = utils.dateFormat(oldMonth);
      if (date.month === oldDate.month) return false;
      month = `${date.year}-${date.month}`;
      this.getData(month);
    }
  },
  mounted() {},
  methods: {
    getData(month) {
      let date = utils.dateFormat(new Date());
      month = month || `${date.year}-${date.month}`;
      let _that = this;
      this.$http({
        method: 'GET',
        params: {
          month,
          day: '',
          klurid: '',
        },
        // url: '/home/getCalendarKolGoodsList',
        url: '/home/getCalendarProjectKolGoodsList',
      }).then(res => {
        if (res.code !== 1) {
          console.error(res.msg);
          return false;
        }
        // 数据格式化
        res.data && _that.formatScheduleData(res.data);
      }).catch(error => {
        console.error(error);
      });
    },
    // 数据格式化
    formatScheduleData(list) {
      let schedule = {};
      let date = utils.dateFormat(this.month);
      let month = `${date.year}-${date.month}`;
      Object.keys(list)
      .forEach(day => {
        schedule[`${month}-${day}`] = Object.keys(list[day]).map(kolId => {
          let kol = { ...list[day][kolId] };
          kol.id = kolId;
        
          // kol.kol_time_begin = utils.dateFormat(new Date(kol.kol_time_begin)).ymd;
          // kol.kol_time_end = utils.dateFormat(new Date(kol.kol_time_end)).ymd;
           kol.kol_time_begin = kol.kol_time_begin.slice(0,10);
           kol.kol_time_end=kol.kol_time_end.slice(0,10)
          // kol.kol_time_end = utils.dateFormat(new Date(kol.kol_time_end)).ymd;
            console.log(kol.kol_time_begin)
          return kol;
        });
      });
      this.schedule = schedule;
    },
    // 更新抽屉显示的数据
    showKolInfo(list, date) {
      if(!list){
        return false
      }
      this.drawer = !this.drawer;
      this.drawerInfo = {
        date,
        kol_list: list.map(info => ({
            id: info.id,
            img: info.kol_user.head_portrait,
            type_name: info.kol_user.type_name,
            nickname: info.kol_user.nickname,
            fans: info.kol_user.fans > 9999 ? this.million(info.kol_user.fans) + 'w' : info.kol_user.fans,
            kol_time_begin: info.kol_time_begin,
            kol_time_end: info.kol_time_end,
            count_all: info.count_all,
            count_suc: info.count_suc,
            home_link:info.kol_user.home_link
          })),
      };
    },
    // 跳转详情页
    goInfopage(klurid, day, month) {
      let date = utils.dateFormat(month);
      this.$router.push({
        name: "usercalendarinfo",
        query: {
          klurid,
          day,
          month: date.month,
        }
      });
    },
    //过万处理
    million(value) {
      let num;
      if(value > 9999){
        num = Number((value/10000).toFixed(1))
        return num;
      }else{
        return value
      }
    },
  },
};
</script>
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.calendar-box {
  padding: 20px;
}
.calendar-box:before ,.calendar-box:after {
  content: '';
  clear: both;
  display: block;
  height: 0;
  width: 0;
}
.statistical{
  display: flex;
  justify-content: space-between;
}
.select-month ,.statistical-list {
  display: inline-block;
}
.statistical-list {
  margin-left: 40px;
}
.statistical-list > li {
  display: inline-block;
  margin-right: 16px;
  cursor: default;
}
.calendar-base >>> .el-calendar-table .el-calendar-day {
  height: 110px;
  overflow: hidden;
  padding:0;
}
.calendar-box .calendar-base >>> .el-calendar-table td.is-selected {
  background: transparent;
}
.calendar-box .calendar-base >>> .el-calendar-table .el-calendar-day:hover {
  background: transparent;
}
.calendar-base .date-cell {
  height: 100%;
  width: 100%;
  position: relative;
}
.calendar-base .date-cell p {
  margin: 5px;
  color: #333;
}
.calendar-base .date-cell .schedule li {
  font-size: 14px;
  /* height:28px; */
}
.calendar-base .date-cell .schedule + p {
  font-size: 14px;
}
/* .calendar-base .date-cell .schedule li span {
  display: inline-block;
  float: left;
} */
.calendar-base .date-cell .schedule li em {
  font-style: normal;
  display: inline-block;
  width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.calendar-base .date-cell .schedule .purple {
  background: #f7e7fb;
  /* margin:; */
  margin-left:8px;
  padding: 4px 8px;
  background: #fef0f0;
  color: #f56c6c;
  font-size: 12px;
  width: 106px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
}
.calendar-base .date-cell .schedule .grey {
  background: #f2f3f4;
  /* margin: 0 0 5px 0; */
  margin-left:8px;
  padding: 4px 8px;
  background: #ededed;
  color: #666;
  font-size: 12px;
  width: 106px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
}
.popover-box p {
  margin: 8px 0;
}
.calendar-box {
  position: relative;
}
.calendar-box >>> .el-dialog__body {
  padding: 0;
}
.drawer-box {
  height: 95%;
  overflow: auto;
}
.drawer-box .kol-list {
  padding-bottom: 36px;
}
.drawer-box .kol-list li {
  margin: 16px 56px 0;
  padding: 16px 136px 0;
  border-top: 1px solid #bbb;
}
.drawer-box .kol-list li .flex-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.drawer-box .kol-list li > p {
  background: rgba(245, 108, 108, .1);
  border-radius: 100px;
  color: #F79393;
  text-align: center;
  line-height: 20px;
  margin: 8px;
  font-size: 12px;
}
.drawer-box .drawer-tit {
  margin: 8px 16px;
  text-align: center;
  color: #666;
}
.drawer-box .drawer-tit span {
  background: #f56c6c;
  color: #fff;
  display: inline-block;
  margin: 0 4px;
  border-radius: 4px;
  padding: 0 6px;
}
.drawer-box .img-box img {
  width: 68px;
  height: 68px;
  margin: 8px;
}
.drawer-box .kol-info {
  margin-left: 16px;
}
.drawer-box .kol-info p {
  margin: 0;
  color: #333;
  line-height: 32px;
}
.drawer-box .kol-info p ~ p {
  color: #666;
}
.cale-box{
  position:absolute;
  left:480px;
  top:76px;
  display: flex;
  font-size:14px;
  color:#666;
  flex-direction: row-reverse;
}
.cale-grea{
  width:11px;
  height: 11px;
  background: #D8D8D8;
  border-radius: 2px;
  margin-right:10px;
}
.cale-greas{
  width:11px;
  height: 11px;
  background: #F56C6C;
  opacity: 0.3;
  border-radius: 2px;
  margin-right:10px;
}
.cale-box-li{
  display: flex;
  align-items: center;
  margin-left:30px;
}

.tatistical-box{
  display: flex;
  align-items: center;
  height:60px;
  justify-content: space-between;
}
.mr-20{
  margin-right:20px;
}
.today{
  display: flex;
  font-size:16px;
  align-items: center;
  justify-content: center;
  width:24px;
  height:24px;
  border-radius: 4px;
  background: #E5A041;
  color:#fff;
}
.today-d{
  display: flex;
  font-size:16px;
  align-items: center;
  justify-content: center;
  width:24px;
  height:24px;
  border-radius: 4px;
  background: #fff;
  color:#333;
}
.more{
  position:absolute;
  top:4px;
  right:2px;
  color:#6435E8;
  font-size:12px;
}
</style>